// settings
// https://swiperjs.com/swiper-api
/*
    <div
        data-controller="swiper"
        class="swiper" 
        data-carousel-options-value="{ }"
    >
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div>Slide 1</div>
            </div>
            <div class="swiper-slide">
                <div">Slide 2</div>
            </div>
            <div class="swiper-slide">
                <div">Slide 3</div>
            </div>
        </div>

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
*/

import {
    Controller
} from "@hotwired/stimulus"
import Swiper from 'swiper';
import {
    Autoplay,
    Navigation,
    Pagination
} from 'swiper/modules'
//https://swiperjs.com/migration-guide-v10
Swiper.use([Navigation, Pagination, Autoplay]);

export default class extends Controller {
    connect() {
        this.swiper = new Swiper(this.element, this.defaultOptions);
    }

    togglePause(event) {
        const btn = event.currentTarget;
        if (this.swiper.autoplay.running) {
            this.swiper.autoplay.stop();
            btn.setAttribute('aria-label', btn.dataset.labelPlay);
            btn.textContent = '▶';
        } else {
            this.swiper.autoplay.start();
            btn.setAttribute('aria-label', btn.dataset.labelPause);
            btn.textContent = '⏸';
        }
    }

    get defaultOptions() {
        return {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
 
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                    loop: false
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    loop: false
                }
            }
        }
    }
}